import { render } from "./HeadNavItem.vue?vue&type=template&id=4a6a0d4a"
import script from "./HeadNavItem.vue?vue&type=script&lang=js"
export * from "./HeadNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cindy/mydoc/project/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__